module.exports = __webpack_public_path__ + "img/9788993260595.97922dd9.jpg";